import actions from './actions';
import getters from './getters';
import mutations from './mutations';

const state = {
    extra_charges: [],
    part_types: [],
};

export default {
    namespaced: true,
    state,
    actions,
    getters,
    mutations,
}
